import { environment } from '@env';

const LOCAL_ASSET_PATTERN = /^(?:\.?\/)?assets\//i;
const STATIC_FILE_EXTENSION_PATTERN =
  /\.(?:svg|png|jpe?g|gif|webp|avif|bmp|ico|woff2?|ttf|eot)$/i;

// Todo download de mídia de conversa passa pelo proxy de CORS, então basta olhar o host:
// pega .pdf, .msg, áudio, vídeo e até URL sem extensão (ig_messaging_cdn), que o filtro
// por extensão deixava passar. Além do volume, essas URLs carregam telefone de hóspede e
// de atendente e um UUID por arquivo — cardinalidade e PII que não valem ser indexadas.
const MEDIA_CORS_PREFIX = `${environment.externalUrls.mediaCors}/`;

// A extensão é testada só no path: rotas como /files/generate/pre-signed-url?filename=foo.png
// terminam em .png e seriam silenciadas por engano se a query string entrasse no teste.
export function isIgnoredForRequestLog(url: string): boolean {
  const path = url.split(/[?#]/)[0];
  return (
    LOCAL_ASSET_PATTERN.test(path) ||
    path.startsWith(MEDIA_CORS_PREFIX) ||
    STATIC_FILE_EXTENSION_PATTERN.test(path)
  );
}
